import React, { Component } from "react";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import Editor from "draft-js-plugins-editor";
import createMentionPlugin from "draft-js-mention-plugin";
import "draft-js-mention-plugin/lib/plugin.css";

class NotesEditorDraftJS extends Component {
  constructor(props) {
    super(props);
    this.mentionPlugin = createMentionPlugin();
  }

  state = {
    editorState: EditorState.createEmpty(),
    users: [],
  };

  componentDidMount() {
    const { users } = this.props;
    const mentionedUsers = this._filterActiveUsers(users);
    this.focus();
    this.setState({
      users: mentionedUsers,
    });
  }

  componentDidUpdate(prevProps) {
    // To maintain the note editor focus in case of Toggle note types "public" and "private",
    // added the "this.focus()" inside the componentDidUpdate also.
    // this.focus();
    if (
      prevProps.rawValue === null &&
      typeof this.props.rawValue === "object"
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        editorState: EditorState.createWithContent(
          convertFromRaw(this.props.rawValue[0]),
        ),
      });
    }
  }

  _filterActiveUsers = users => {
    let mentionedUsers = [];
    if (users && users.length > 0) {
      mentionedUsers = users.filter(user => user.is_active);
    }
    return mentionedUsers;
  };

  onChange = editorState => {
    this.setState({
      editorState,
    });
    // put a check here to stop this call if es contains no text
    this.props.handleNoteObjChange(
      convertToRaw(editorState.getCurrentContent()),
    );
  };

  customFilter = value => {
    const mentionedUsers = this._filterActiveUsers(this.props.users);
    if (value.length === 0) {
      return mentionedUsers;
    }
    return mentionedUsers.filter(user =>
      user.name.toLowerCase().startsWith(value.toLowerCase()),
    );
  };

  onSearchChange = ({ value }) => {
    this.setState({
      users: this.customFilter(value),
    });
  };

  // https: // github.com/revvsales/reactgrid/pull/748#discussion_r323632293
  onAddMention = () => {};

  focus = () => {
    setTimeout(() => {
      if (this.editor) {
        this.editor.focus();
      }
    }, 0);
  };

  render() {
    const { MentionSuggestions } = this.mentionPlugin;
    const plugins = [this.mentionPlugin];
    const { isSharedDocument } = this.props;
    return (
      <div
        onClick={this.focus}
        onKeyPress={() => null}
        role="button"
        tabIndex="0">
        <Editor
          editorState={this.state.editorState}
          onChange={es => this.onChange(es)}
          plugins={plugins}
          ref={element => {
            this.editor = element;
          }}
          placeholder={
            isSharedDocument ? "type here..." : "Use @ to mention someone..."
          }
          data-test="noteseditordraftjs-note-textarea"
        />
        {!isSharedDocument && (
          <MentionSuggestions
            onSearchChange={this.onSearchChange}
            suggestions={this.state.users}
            onAddMention={this.onAddMention}
          />
        )}
      </div>
    );
  }
}

export default NotesEditorDraftJS;
